/**
 * CrowdTalkie App
 *
 * Main application component with routing.
 */

import { Routes, Route } from 'react-router-dom'
import { HomePage } from './pages/Home'
import { CreatePage } from './pages/Create'
import { JoinPage } from './pages/Join'
import { RoomPage } from './pages/Room'
import { DocsPage } from './pages/Docs'
import { MeshHardwarePage } from './pages/MeshHardware'
import { P2PProvider } from './contexts/P2PContext'


// Main App component
export default function App() {
  return (
    <P2PProvider>
      {/* paddingTop keeps headers clear of the iPhone status bar / Dynamic Island (viewport-fit=cover); 0 elsewhere */}
      <div className="w-screen overflow-hidden bg-black" style={{ height: '100dvh', paddingTop: 'env(safe-area-inset-top)' }}>
        {/* Device Container - Now Full Screen */}
        <div className="device-screen">
          {/* Main Content Area - pages manage their own scrolling */}
          <div className="flex-1 flex flex-col relative z-10 overflow-hidden bg-tactical-dark">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/create" element={<CreatePage />} />
              <Route path="/join" element={<JoinPage />} />
              <Route path="/join/:roomId" element={<JoinPage />} />
              <Route path="/room/:roomId" element={<RoomPage />} />
              <Route path="/docs" element={<DocsPage />} />
              <Route path="/mesh-hardware" element={<MeshHardwarePage />} />
            </Routes>
          </div>
        </div>
      </div>
    </P2PProvider>
  )
}
